import { CloudProductKey } from "@/components/wpl/pricing/src/price-finder/constants";

export const SignupUrlSuffix = {
    free: "?bundle=jira-software&edition=free&editionIntent=free",
    standard: "?bundle=jira-software&edition=standard",
    premium: "?bundle=jira-software&edition=premium"
};
export const DATA_PRODUCT_KEY = "jiraSoftware" as CloudProductKey;

export const PriceDisplayMessages = {
    exceedsUserLimit: {
        id: "Pricing.PriceCard.PriceDisplayMessage.ExceedsUserLimit",
        defaultMessage: "Your user count exceeds this plan's limit"
    }
} as const;
